import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ParkingLotPageComponent } from "@onsip/web/features/administrators/parkingLot/parkingLotPage/parking-lot-page.component";
import { ParkingLotRoutingModule } from "@onsip/web/features/administrators/parkingLot/parking-lot-routing.module";
import { RouterModule } from "@angular/router";
import { MaterialModule } from "@onsip/web/modules/material/material.module";
import { ReactiveFormsModule } from "@angular/forms";
import { TableModule } from "@onsip/web/features/shared/components/table/onsip-table.module";
import { PipesModule } from "@onsip/web/features/shared/pipes/pipes.module";
import { TranslateModule } from "@ngx-translate/core";
import { ParkingLotShelfContainerComponent } from "./parkingLotShelfContainer/parking-lot-shelf-container.component";
import { ParkingLotSettingsEditComponent } from "./parkingLotShelfEdit/parkingLotSettingsEdit/parking-lot-settings-edit.component";
import { ParkingLotSettingsViewComponent } from "./parkingLotShelfView/parkingLotSettingsView/parking-lot-settings-view.component";
import { CallerSettingsEditComponent } from "./parkingLotShelfEdit/callerSettingsEdit/caller-settings-edit.component";
import { CallerSettingsViewComponent } from "./parkingLotShelfView/callerSettingsView/caller-settings-view.component";
import { ParkingLotFormComponent } from "@onsip/web/features/administrators/parkingLot/parking-lot-form.component";
import { EditItemListModule } from "@onsip/web/features/shared/components/onsipItemList/edit-item-list.module";
import { ParkingLotSetupComponent } from "./parkingLotSetup/parking-lot-setup.component";
import { ExtensionsListModule } from "@onsip/web/features/shared/components/extensionsList/extensions-list.module";
import { AddressAutocompleteModule } from "@onsip/web/features/administrators/addressAutocomplete/address-autocomplete.module";
import { SipAddressFieldModule } from "../../shared/components/sipAddressField/sip-address-field.module";
import { TableDataLoadContainerModule } from "../../shared/components/tableDataLoadContainer/table-data-load-container.module";
import { ParkingLotEmptyDataComponent } from "./parking-lot-empty-data/parking-lot-empty-data.component";
import { LoadingContainerComponent } from "../../shared/components/loadingContainer/loading-container.component";

@NgModule({
  declarations: [
    ParkingLotPageComponent,
    ParkingLotShelfContainerComponent,
    ParkingLotSettingsEditComponent,
    ParkingLotSettingsViewComponent,
    CallerSettingsEditComponent,
    CallerSettingsViewComponent,
    ParkingLotFormComponent,
    ParkingLotSetupComponent,
    ParkingLotEmptyDataComponent
  ],
  imports: [
    CommonModule,
    ParkingLotRoutingModule,
    RouterModule,
    MaterialModule,
    ReactiveFormsModule,
    TableModule,
    PipesModule,
    TranslateModule,
    SipAddressFieldModule,
    EditItemListModule,
    ExtensionsListModule,
    AddressAutocompleteModule,
    TableDataLoadContainerModule,
    LoadingContainerComponent
  ]
})
export class ParkingLotModule {}
